import UUID from 'uuidjs'
const imageConversion = require("image-conversion")

function convertBase64UrlToBlob(dataUrl, type) {
    var arr = dataUrl.split(',')
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: type })
}

async function compressImage(file,cp) {
    return await imageConversion.compressAccurately(file, cp)
}

function fileReader(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            var url = e.target.result;
            var one = {
                id: UUID.generate(),
                file: file,
                url: url,
                status: 3,
                remotePath: '',
                attname: file.name,
                type: file.name.substr(file.name.lastIndexOf(".") + 1).toLowerCase(),
                size: formatSize(file.size)
            }
            if (isImage(file.name)) {
                var img = new Image();
                img.src = url;
                img.onload = function () {
                    one.img = true;
                    one.width = this.width;
                    one.height = this.height;
                    resolve(one)
                }
            } else {
                resolve(one)
            }
        };
    })
}

function isImage(filePath) {
    var index = filePath.lastIndexOf(".");
    var ext = filePath.substr(index + 1);
    //'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'
    return ['png', 'jpg', 'jpeg'].indexOf(ext.toLowerCase()) !== -1;
}

function isAudio(filePath) {
    var index = filePath.lastIndexOf(".");
    var ext = filePath.substr(index + 1);
    return ['mp3', 'wav'].indexOf(ext.toLowerCase()) !== -1;
}

function isPreview(filePath) {
    var index = filePath.lastIndexOf(".");
    var ext = filePath.substr(index + 1);
    return ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'png', 'jpg', 'jpeg'].indexOf(ext.toLowerCase()) !== -1;
}

function formatSize(size) {
    if (!size) {
        return "";
    }
    var num = 1024.00; //byte
    if (size < num)
        return size + "B";
    if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + "K"; //kb
    if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
    if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
    return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
}

export {
    convertBase64UrlToBlob,
    compressImage,
    fileReader,
    formatSize,
    isAudio,
    isImage,
    isPreview
}


// WEBPACK FOOTER //
// ./src/components/common/file.js